<template>
  <div>
        <!--<b-container>    -->
            <b-list-group variant="primary">
                <b-list-group-item class="d-flex justify-content-between align-items-center">
                    <b-badge pill variant="primary">U$D {{this.$store.state.dolar | formato }}</b-badge>
                    <b-badge pill variant="primary">UF {{this.$store.state.uf | formato }}</b-badge>
                    <b-badge pill variant="primary">UTM {{this.$store.state.utm | formato }}</b-badge>
                    <b-badge pill variant="primary">Euro {{this.$store.state.euro | formato }}</b-badge>
                    <b-badge pill variant="primary">IPC {{this.$store.state.ipc }}</b-badge>
                </b-list-group-item>
            </b-list-group>            
        <!--</b-container>-->
  </div>
</template>

<script>
export default {
    name:'indicadoreseconomicos'
}
</script>

<style>

</style>